import axios, { AxiosResponse } from 'axios';

/**
 * @description 推播訊息已讀請求物件
 * @property {number[]} ids - 推播訊息id列表
 */
export interface TRequest {
    ids: number[];
}

/**
 * @description 推播訊息已讀
 * @param {TRequest} request - 請求物件
 * @returns {Promise<AxiosResponse<unknown, TRequest>>} - 回應物件
 */
export default async function apiPushNoticeReadLittleBell(request: TRequest) {
    const response: AxiosResponse<unknown, TRequest> = await axios.request({
        url: `/api/push-notice/read-little-bell`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: request,
    });

    return response;
}
